// extracted by mini-css-extract-plugin
module.exports = {"startAdornment":"UsernameInput_startAdornment__TkFSb","inputWithAdornment":"UsernameInput_inputWithAdornment__YTqAf","labelWithAdornment":"UsernameInput_labelWithAdornment__C1SP1"};